<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="display-1">Pacchetti sedute dell'utente "{{userName}}"</h2>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>
      <v-col cols="12" v-for="item in seats" :key="item._id">

        <v-card variant="outlined">
          <v-card-text>

            <div class="d-flex flex-wrap align-center">
              <h2>Pacchetto {{item.consumable ? 'a sedute limitate' : 'a scadenza temporale'}} con accesso a:&nbsp;</h2>
              <v-chip size="small" class="font-weight-bold text-uppercase mr-2" variant="tonal" v-for="(st, j) in item.seats_types"
                      :key="`valid_us_${item._id}_st_${j}`"  :color="getSeatsTypeColor(st)">{{getSeatsTypeLabel(st)}}</v-chip>
            </div>
            <h3 v-if="item.expiration" class="font-weight-bold">Scadenza: {{formatDate(item.expiration)}}</h3>
            <h3 v-else class="font-weight-bold">Scadenza: -</h3>
            <v-row v-if="item.consumable" no-gutters class="mt-3">
              <v-col cols="12">
                <h3 class="font-weight-bold">N° sedute utilizzabili <span class="text-primary">{{item.available - item.used}}</span> di {{item.available}} a disposizione ({{item.used}} utilizzate)</h3>
                <small>Qui puoi aggiungere o rimuovere sedute a disposizione per questo pacchetto (non puoi scendere sotto il numero di sedute utilizzate)</small>
              </v-col>
              <v-col cols="12" class="pt-1">
                <div class="d-flex">
                  <v-btn rounded size="small" color="primary" class="mr-2" @click="editAvailable(item,-10)" :loading="seatsLoading" :disabled="seatsLoading">-10</v-btn>
                  <v-btn rounded size="small" color="primary" class="mr-2" @click="editAvailable(item,-1)" :loading="seatsLoading" :disabled="seatsLoading">-1</v-btn>
                  <v-btn rounded size="small" color="primary" class="mr-2" @click="editAvailable(item,1)" :loading="seatsLoading" :disabled="seatsLoading">+1</v-btn>
                  <v-btn rounded size="small" color="primary" class="mr-2" @click="editAvailable(item,10)" :loading="seatsLoading" :disabled="seatsLoading">+10</v-btn>
                </div>
              </v-col>
            </v-row>


            <h3 class="mt-3 mb-2">Imposta una data scadenza</h3>
            <v-row >
              <v-col cols="12" md="6" lg="4">
                <date-field label="Nuova scadenza"  v-model="item.expiration" ></date-field>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <v-btn rounded color="primary" size="small" class="my-2" @click="saveItem(item)" :loading="seatsLoading" :disabled="seatsLoading">Salva</v-btn>
              </v-col>

            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn rounded color="error" class="ml-3 mb-2" @click="deleteItem(item)">Elimina questo pacchetto sedute</v-btn>
          </v-card-actions>
        </v-card>
        <!--<p>{{item}}</p>-->

      </v-col>
      <v-col cols="12" >
        <v-divider class="my-4"></v-divider>
        <!--<p>{{item}}</p>-->
        <h2>Aggiungi un pacchetto sedute</h2>

        <v-form ref="customForm" @submit.prevent="onAddCustomSeats()" class="mt-4">
          <v-row>
            <v-col cols="12" md="6" lg="4" xl="3" >
              <v-select  label="Tipologia custom" v-model="addSeatsCustomType"  :items="addSeatsCustomTypeOptions"></v-select>
            </v-col>
            <v-col cols="12" md="6" lg="4"  >
              <v-select  label="Tipo Sedute" v-model="addSeatsCustom.seats_types"
                         :items="seatsTypesOptions" multiple chips deletable-chips :rules="[rules.required, rules.notEmpty]"></v-select>
            </v-col>
            <v-col cols="12" class="mx-0 my-0 px-0 py-0"></v-col>

            <v-col cols="12" md="6" lg="4" xl="3" v-if="addSeatsCustomType === 'consumable'">
              <v-text-field type="number"  step="1" min="1" label="Durata (in giorni dal primo utilizzo)"
                            v-model="addSeatsCustom.duration" :rules="[rules.required, rules.minInt(1)]"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="4" xl="3" v-if="addSeatsCustomType !== 'consumable'">
              <v-text-field type="date"  label="Scadenza" v-model="addSeatsCustom.expiration" :rules="[rules.required]"></v-text-field>
            </v-col>

            <v-col cols="12" md="6" lg="4" xl="3" v-if="addSeatsCustomType !== 'expiration'">
              <v-text-field type="number"  step="1" min="1" label="N° sedute" v-model="addSeatsCustom.available" :rules="[rules.required, rules.minInt(1)]"></v-text-field>
            </v-col>

            <v-col cols="12" md="6" lg="4" xl="3" >
              <v-btn rounded color="primary" type="submit">Inserisci Pacchetto</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import {seatsTypesOptions} from "../consts";
import DateField from "../components/DateField.vue";
import rules from "../utils/rules";
import {DateTime} from "luxon";
import {SeatsType, type User, type UserSeat} from "@/models.js";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import {type Messages, Msg} from "@/plugins/messages.ts";
import api from "@/api";
import {useRoute, useRouter} from "vue-router";
import type {Auth} from "@/plugins/auth.ts";

export default {
  name: "UserSeats",
  components: {DateField},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const messages = inject('messages') as Messages;
    const auth = inject('auth') as Auth;

    const customForm = useTemplateRef<any>('customForm')

    const loading = ref(false)
    const seatsLoading = ref(false)
    const user = ref<User|undefined>()
    const seats = ref<UserSeat[]>([])
    const _addSeatsCustomType = ref<'consumable'|'expiration'|'both'>('consumable')

    const addSeatsCustom = ref<UserSeat>({
      user_id : '',
      consumable : true,
      seats_types : [],
      available : 0,
      used : 0,
      duration : 365,
      shared_expiration : false,
      expiration : undefined,
    })

    const loadData = async () => {
      loading.value = true;
      await router.isReady()
      let id = route.params.id as string;
      const res = await api.get<User>('users', id)

      if(!res.success) {
        loading.value = false;
        if(res.status === 401) {
          messages.error("non hai i permessi per vedere questo pannello")
          auth.logout()
          await router.replace('/')
          return
        }
        messages.error(res.message ?? Msg.serverError)
        return
      }
      user.value = res.data!
      const res2 = await api.list<UserSeat>('userseats', {user:id}, 0,0)
      if(!res2.success) {
        loading.value = false;
        if(res2.status === 401) {
          messages.error("non hai i permessi per vedere questo pannello")
          auth.logout()
          await router.replace('/')
          return
        }
        messages.error(res2.message ?? Msg.serverError)
        return
      }
      seats.value = res2.data ?? []
      loading.value = false;
    }

    const saveItem = async (item:UserSeat) => {
      if(!item.consumable && !item.expiration) {
        messages.error('Un pacchetto a scadenza temporale deve avere una data di scadenza!');
        return
      }

      seatsLoading.value = true;
      const res = await api.post<UserSeat>('userseats', item)
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError);
      }
      seatsLoading.value = false
      await loadData();
    }

     onMounted(async () => {
       await loadData();
     })

    return {
      loading,
      SeatsType,
      rules,
      seatsLoading,
      user,
      seats,
      addSeatsCustom,
      addSeatsCustomTypeOptions : [
        { title : 'Con sedute a consumo', value : 'consumable' },
        { title : 'A scadenza fissa', value : 'expiration' },
        { title : 'Sedute a consumo + scadenza fissa', value : 'both' }
      ],
      addSeatsCustomType : computed<'consumable'|'expiration'|'both'>({
        get() {
          return _addSeatsCustomType.value
        },
        set(value) {
          _addSeatsCustomType.value = value
          addSeatsCustom.value.consumable = _addSeatsCustomType.value !== 'expiration'
          if(_addSeatsCustomType.value === 'consumable') {
            addSeatsCustom.value.expiration = undefined
            addSeatsCustom.value.duration = 365
          } else {
            addSeatsCustom.value.duration = 0
          }
          if(_addSeatsCustomType.value === 'expiration') {
            addSeatsCustom.value.available = 0
          }
        }
      }),
      seatsTypesOptions,
      userName : computed(() => user.value ? `${user.value.name} ${user.value.surname}` : '-'),
      formatDate : utils.formatDate,
      async editAvailable(item:UserSeat, num:number) {
        const target = item.available + num
        if(target < item.used) {
          messages.error('Non puoi rimuovere ulteriori sedute')
          return;
        }
        item.available = target
        await saveItem(item)
      },
      saveItem,
      deleteItem(item:UserSeat) {
        messages.requestConfirm('Richiesta conferma','Sei sicuro di voler eliminare questo pacchetto di sedute?', false, async ok => {
          if(ok) {
            seatsLoading.value = true;
            const res = await api.del('userseats', item._id as string)
            if(!res.success) {
              messages.error(res.message ?? Msg.serverError);
            }
            seatsLoading.value = false;
            await loadData()
          }
        })
      },
      getSeatsTypeLabel(st:SeatsType):string {
        const opt = seatsTypesOptions.find(option => option.value === st)
        return opt?.title ?? st
      },
      getSeatsTypeColor(st:SeatsType):string {
        const opt = seatsTypesOptions.find(option => option.value === st)
        return opt?.color ?? st
      },
      customForm,
      async onAddCustomSeats() {
        const v = await customForm.value!.validate()
        if(!v.valid) return;

        messages.requestConfirm('Richiesta conferma', 'Sei sicuro di aggiungere questo pacchetto?', false, async ok => {
          if(!ok) return;
          loading.value = true;
          let data = { ...addSeatsCustom.value }
          if(data.expiration) {
            const d = DateTime.fromISO(data.expiration)!
            data.expiration = d.toISO()!
          }

          data.user_id = route.params.id as string;
          data.duration = utils.toInt(data.duration, 0)
          data.available = utils.toInt(data.available, 0)

          const res = await api.post<UserSeat>('userseats', data)

          if(!res.success) {
            messages.error(res.message ?? Msg.serverError);
          }
          await loadData()
          loading.value = false;

        })
      },
    }
  }
}
</script>



<style scoped>

</style>